import {
    GET_LIST_RECEIPTS,
    REMOVE_RECEIPTS,
    GET_ACTIVE_RECEIPTS
} from '@/redux/actions/types';

const INIT_STATE = {
    receipt_list: [],
    receipt_summary: {
        special_discount: 0,
        amount_paid: 0,
    },
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_RECEIPTS: {
            return {
                ...state,
                receipt_list: action.payload?.data || [],
                receipt_summary: {
                    special_discount: Number(action.payload?.summary?.special_discount) || 0,
                    amount_paid: Number(action.payload?.summary?.amount_paid) || 0,
                },
                pagination: {
                    currentPage: parseInt(action.payload?.current_page || 1),
                    total: parseInt(action.payload?.total || 0),
                    perPage: parseInt(action.payload?.per_page || 30),
                }
            };
        }

        case GET_ACTIVE_RECEIPTS: {
            const listReceipts = [...state.receipt_list, ...(action.payload?.data || [])];

            return {
                ...state,
                receipt_list: listReceipts.filter((v, i, a) => a.findIndex(v2 => v2.id === v.id) === i),
                pagination: {
                    currentPage: parseInt(action.payload?.current_page || 1),
                    total: parseInt(action.payload?.total || 0),
                    perPage: parseInt(action.payload?.per_page || 30),
                }
            };
        }

        case REMOVE_RECEIPTS: {
            const temp = state.receipt_list.filter(item => action.payload.indexOf(item.id) < 0);
            return { ...state, receipt_list: temp };
        }

        default:
            return { ...state };
    }
};
